import { client } from '../../../../shared/services/apiClient';
import { ApiKeyResponse, CreateApiKeyRequest, EditApiKeyRequest } from '../models/ApiKeyResponse';

export const getApiKeys = async (): Promise<ApiKeyResponse[]> => {
  return client(true, true)
    .get<ApiKeyResponse[]>('/api-keys/data')
    .then((response) => response.data)
    .catch((error) => error);
};

export const createApiKey = async (request: CreateApiKeyRequest): Promise<ApiKeyResponse> => {
  const response = await client(true, true).post<ApiKeyResponse>('/api-keys/data', request);
  return response.data;
};

export const deleteApiKey = async (key: string): Promise<{ success: boolean }> => {
  return client(true, true)
    .delete<{ success: boolean }>(`/api-keys/data/${key}`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const editApiKey = async (key: string, request: EditApiKeyRequest): Promise<{ success: boolean }> => {
  return client(true, true)
    .put<{ success: boolean }>(`/api-keys/data/${key}/edit`, request)
    .then((response) => response.data)
    .catch((error) => error);
};
